import applyBulkItemActionOperation from 'owa-service/lib/operation/applyBulkItemActionOperation';
import ApplyBulkItemActionRequest from 'owa-service/lib/contract/ApplyBulkItemActionRequest';
import ApplyBulkItemActionResponseMessage from 'owa-service/lib/contract/ApplyBulkItemActionResponseMessage';
import BulkTriageActionType from 'owa-service/lib/contract/BulkTriageActionType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import FolderId from 'owa-service/lib/contract/FolderId';
import SetItemField from 'owa-service/lib/contract/SetItemField';
import { getJsonRequestHeader } from 'owa-service/lib/Utils';

/**
 * Always move to Focused or Other Service
 * @param sourceFolderId the source folderId
 * @param emailAddresses emailaddresses
 * @param itemPropertytoUpdate the item property to update
 * @return the ApplyBulkItemActionResponseMessage
 */
export function alwaysMoveToFocusedOtherService(
    sourceFolderId: FolderId,
    emailAddresses: EmailAddressWrapper[],
    itemPropertytoUpdate: SetItemField
): Promise<ApplyBulkItemActionResponseMessage> {
    const requestBody: ApplyBulkItemActionRequest = {
        SourceFolderId: sourceFolderId,
        EmailAddresses: emailAddresses,
        ActionType: BulkTriageActionType.MoveToFocusedOther,
        ItemPropertyToUpdate: itemPropertytoUpdate,
    };

    return applyBulkItemActionOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    })
        .then(response => {
            return response.Body.ResponseMessages.Items[0];
        })
        .catch(error => {
            return Promise.reject(error);
        });
}
